function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74DAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0070DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  rx: 32
}), /*#__PURE__*/React.createElement("filter", {
  x: "-85.9%",
  y: "-54.7%",
  width: "271.9%",
  height: "271.9%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.329350825 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "10.10\\u6700\\u7EC8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0-10.14",
  transform: "translate(-898.000000, -1311.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(-92.000000, 1273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3",
  transform: "translate(457.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cddc",
  transform: "translate(563.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u4EA7\\u54C1\\u56FE\\u6807/ddos-DDoS\\u9632\\u62A4",
  transform: "translate(18.000000, 16.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F62\\u72B6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.63726708,9.9378882 L3.63726708,21.7838509 L13.8136646,27.7465839 L24.089441,21.863354 L24.089441,10.0173913 L13.9130435,4.05465839 L3.63726708,9.9378882 Z M22.2012422,20.710559 L13.8335404,25.5204969 L5.54534161,20.710559 L5.54534161,11.0906832 L13.9130435,6.30062112 L22.2012422,11.110559 L22.2012422,20.710559 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7291925,4.13416149 L17.6496894,2.38509317 L13.8335404,0.159006211 L10.0173913,2.40496894 L10.0173913,4.23354037 L13.9130435,1.98757764 C13.9130435,1.98757764 17.7291925,4.13416149 17.7291925,4.13416149 Z M10.0173913,27.6670807 L10.0968944,29.4161491 L13.9130435,31.642236 L17.7291925,29.4161491 L17.7291925,27.5875776 L13.8335404,29.8136646 L10.0173913,27.6670807 Z M1.82857143,18.226087 L0.178881988,19.2198758 L0.178881988,23.6124224 L4.05465839,25.8385093 L5.62484472,24.9242236 L1.80869565,22.6981366 C1.80869565,22.6981366 1.82857143,18.226087 1.82857143,18.226087 Z M1.82857143,8.94409938 L5.6447205,6.69813665 L4.07453416,5.78385093 L0.258385093,8.02981366 L0.258385093,12.4223602 L1.90807453,13.4161491 C1.90807453,13.4161491 1.82857143,8.94409938 1.82857143,8.94409938 Z M25.9975155,18.3850932 L26.0770186,22.8571429 L22.2608696,25.0832298 L23.8310559,25.9975155 L27.647205,23.7714286 L27.647205,19.4583851 L25.9975155,18.3850932 Z M25.9975155,13.4161491 L27.5677019,12.4223602 L27.647205,8.10931677 L23.7515528,5.78385093 L22.1813665,6.69813665 L25.9975155,9.02360248 L25.9975155,13.4161491 Z M7.61242236,19.378882 L13.3167702,22.7776398 L13.3167702,16.3180124 L7.61242236,13.2571429 L7.61242236,19.378882 Z M14.4099379,22.7776398 L20.1341615,19.6372671 L20.1341615,13.2571429 L14.4099379,16.3180124 L14.4099379,22.7776398 L14.4099379,22.7776398 Z M7.87080745,12.1639752 L13.8335404,15.3838509 L19.8757764,12.3428571 L13.7540373,9.02360248 L7.87080745,12.1639752 Z"
}))))))));

function SvgGroup13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup13);
export default __webpack_public_path__ + "static/media/group1_3.d44bd713.svg";
export { ForwardRef as ReactComponent };